import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Tevent } from "../type/event";
import { postDataPages } from "../service/eventService";
import { showMessage } from "../utls/message";


export interface eventsSlice {
    eventsPage: Tevent[],
    totalRows: number;
    pageNo: number;
    pageSize: number;
}

const initialState: eventsSlice = {
    eventsPage: [],
    totalRows: 0,
    pageNo: 0,
    pageSize: 10
}

export const postDataPage = createAsyncThunk("events/filter",
    async (data: any) => {
        const response = await postDataPages(data);
        if (response?.code === 200 && !response.error) {
            return response.data;
        } else {
            showMessage(`${response?.code} ${response?.message}`, "danger");
            return initialState;
        }
    }
);

const eventsSlice = createSlice({
    name: "events",
    initialState,
    reducers: {
        setPageNo: (state, action) => {
            state.pageNo = action.payload;
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(postDataPage.fulfilled, (state, action) => {
                if (action.payload.content) {
                    state.eventsPage = action.payload.content;
                    state.totalRows = action.payload.totalElements;
                } else {
                    state.eventsPage = [];
                    state.totalRows = 0;
                }
            });
    }
});

export const { setPageNo, setPageSize } = eventsSlice.actions;
export default eventsSlice.reducer;
